import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";

interface BrandingContextValue {
  logoVersion: number;
  bumpLogoVersion: () => void;
}

const BrandingContext = createContext<BrandingContextValue | null>(null);

export function BrandingProvider({ children }: { children: ReactNode }) {
  const [logoVersion, setLogoVersion] = useState<number>(() => Date.now());
  const bumpLogoVersion = useCallback(() => setLogoVersion(Date.now()), []);
  const value = useMemo(() => ({ logoVersion, bumpLogoVersion }), [logoVersion, bumpLogoVersion]);
  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
}

export function useBranding(): BrandingContextValue {
  const ctx = useContext(BrandingContext);
  if (!ctx) throw new Error("useBranding must be used inside BrandingProvider");
  return ctx;
}
